import React from 'react';
import Person from '../Modules/AboutUs/PersonBio';

function About() {
  return (
    <div className='aboutUsHome'>
      <Person />
    </div>
  );
}

export default About;